import type { AxiosError } from "axios";
import { cache } from "react";
import type { CountryType, Nullable } from "../../../@types/generic";
import { fetcher, isAxiosError } from "../index";
import type { Location } from "../types/locations";

export const getLocation = cache(
    async (
        code: string | undefined,
        country: CountryType
    ): Promise<Nullable<Location>> => {
        if (!code) {
            return Promise.resolve(null);
        }

        return await fetcher<Location>(
            { path: `/locations/${code}/` },
            { country }
        ).catch((error: Error | AxiosError) => {
            if (isAxiosError(error) && error.status === 404) {
                return Promise.resolve(null);
            }

            return Promise.reject(error);
        });
    }
);
